<template>
    <div class="base-layout">
        <AppHeader :key="'app-header'"/>
        <div>
            <div class="default-layout">
                <div class="container mx-auto py-4">
                    <div class="grid grid-cols-12 gap-4 max-[768px]:m-2">
                        <div class="contact md:col-start-1 lg:col-end-5 col-span-12"
                             :class="[
              {
                'contact_without_border':
                  currentView === 'chat',
                },
              ]">
                            <div class="lg:hidden" v-if="currentView === 'chat'">
                                <button class="btn btn-black mb-4" type="button"
                                        @click="currentView === 'list' ? currentView = 'chat' : currentView = 'list'">
                                    <ArrowIcon class="m-4" :class="{'flip-x': currentView === 'chat'}"/>
                                </button>
                            </div>
                            <div :class="{'hide-chat-section': currentView !== 'list'}">
                                <Suspense>
                                  <AiChatList />
                                </Suspense>
                            </div>
                        </div>
                        <NuxtPage class="lg:col-span-8 col-span-12"
                                  :class="{'hide-chat-section': currentView !== 'chat'}"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script setup>
import ArrowIcon from "../assets/img/icons/arrow.svg";
import {storeToRefs} from "pinia";
import AiChatList from "../components/Chat/AiChatList.vue";

const {t: $t} = useI18n()


const route = useRoute()
const localePath = useLocalePath()
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const chatId = route.params.id

const {userInfo} = storeToRefs(useUserStore())

const {currentView} = storeToRefs(useChatStore())

if (chatId !== undefined) {
    currentView.value = 'chat';
}
</script>
<style lang="scss" scoped>
.contact {
  box-shadow: inset 0 10px 30px 15px rgba(56, 112, 255, 0.2);
}
</style>
